// Иконки Lucide. Проект на ванильном TS (не React), поэтому пакет `lucide`, а не
// `lucide-react`: он даёт те же SVG.
//
// В разметке ставим <i data-lucide="имя">, после каждого innerHTML с иконками
// зовём renderIcons() — она заменяет заглушки на настоящие svg. Импортируем
// только нужные иконки поимённо, чтобы в бандл не уехала вся тысяча.
import { createIcons, Check, Search, ShoppingCart, Trash2, X } from 'lucide';

// Ключи — PascalCase; createIcons сам сопоставит их с kebab в data-lucide
// (ShoppingCart → data-lucide="shopping-cart").
const used = { Check, Search, ShoppingCart, Trash2, X };

export function renderIcons(root: HTMLElement | Document = document): void {
  createIcons({ icons: used, attrs: { 'stroke-width': 2 }, nameAttr: 'data-lucide', root });
}
